import { ACTION_TYPE } from './action';

// #region Reducer
const loginUser = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.LOGIN_SUCCESS:
      return {
        ...state,
        result: action.token,
        isError: false,
      };
    case ACTION_TYPE.LOGIN_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isError: true,
      };
    case ACTION_TYPE.LOGIN_DATA_RESET:
      return {
        ...state,
        result: null,
        isError: null,
      };
    case ACTION_TYPE.GET_ME_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isGetMeError: true,
      };
    case ACTION_TYPE.GET_ME_SUCCESS:
      return {
        ...state,
        user: action.data,
        isGetMeError: false,
      };
    case ACTION_TYPE.RESET_GET_ME_FLG:
      return {
        ...state,
        isGetMeError: false,
      };
    default:
      return state;
  }
};

export default loginUser;
